// removed by extract-text-webpack-plugin
module.exports = {"container":"EvvAWDjYKVTen6CWVA83e","hasLightBg":"_3oWXp0-jo3_q1alPLDXEDL","noSpacing":"_7lSfzRrktBHvWJVRvn_qt","grid":"_3Tv8ld3k62_XJbX5DPi4fz","gridNoSpacing":"t87VfCCNFufckx4SIdr2B","copy":"ZkrAinhbfWU1mSUKIPlcQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Newsletter/styles.css
// module id = 313
// module chunks = 0